<script>
import router from "@/router";

import { layoutComputed } from "@/state/helpers";
import NavbarGuest from "@/components/nav-bar-guest.vue";

localStorage.setItem("hoverd", false);

/**
 * Vertical layout
 */
export default {
  components: {
    NavbarGuest,
  },
  watch: {
    $route: {
      handler: "onRoutechange",
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isMenuCondensed: false,
      title: "",
      pageTitle: "",
      menuItems: [],
    };
  },
  computed: {
    ...layoutComputed,
  },
  async created() {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
  },
  methods: {
    onRoutechange(ele) {
      this.title = ele.meta.title;
      this.pageTitle = ele.meta.breadcrumbText;
    },
    updateSidebarSize() {
      let sidebarSize = "";
      // Check window.screen.width and update the data-sidebar-size attribute
      if (window.innerWidth < 1025) {
        this.$store.dispatch("layout/changeSidebarSize", { sidebarSize: "sm" });
        sidebarSize = "sm";
      } else {
        this.$store.dispatch("layout/changeSidebarSize", { sidebarSize: "lg" }); // Reset sidebarSize if screen width is >= 1025
        sidebarSize = "lg";
      }
      // Update the data-sidebar-size attribute of document.documentElement
      document.documentElement.setAttribute("data-sidebar-size", sidebarSize);
    },
    initActiveMenu() {
      if (
        document.documentElement.getAttribute("data-sidebar-size") ===
        "sm-hover"
      ) {
        localStorage.setItem("hoverd", true);
        document.documentElement.setAttribute(
          "data-sidebar-size",
          "sm-hover-active"
        );
      } else if (
        document.documentElement.getAttribute("data-sidebar-size") ===
        "sm-hover-active"
      ) {
        localStorage.setItem("hoverd", false);
        document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
      } else {
        document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
      }
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");
      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {},
  unmounted() {
    window.removeEventListener("resize", this.updateSidebarSize);
  },
};
</script>

<template>
  <div class="auth-page-wrapper pt-3" id="layout-wrapper">
    <NavbarGuest />
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->

    <div class="auth-main-content mt-5">
      <div class="auth-page-content">
        <BContainer fluid>
          <slot />
        </BContainer>
      </div>
    </div>
  </div>
</template>
